
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.37 6.887c-.356.82-1.138 1.507-1.9 1.507-.925 0-1.6-.682-1.963-1.5-2.087 1.081-1.825 3.812-1.825 3.812 0 .375.294.431.644.431H9.607c.35 0 .644-.056.644-.43 0 .005.207-2.738-1.881-3.82z","fill":"#D0DAE6"}}),_c('path',{attrs:{"d":"M6.467 7.95c1.044 0 1.875-1.494 1.875-2.731 0-1.238-.85-2.238-1.894-2.238-1.043 0-1.893 1-1.893 2.238.006 1.231.868 2.731 1.912 2.731z","fill":"#D0DAE6"}}),_c('path',{attrs:{"d":"M18.125 0H1.875A1.872 1.872 0 000 1.875V12.5c0 1.037.838 1.875 1.875 1.875h16.25A1.872 1.872 0 0020 12.5V1.875A1.872 1.872 0 0018.125 0zm.625 12.5a.627.627 0 01-.625.625H1.875a.627.627 0 01-.625-.625V1.875c0-.344.281-.625.625-.625h16.25c.344 0 .625.281.625.625V12.5z","fill":"#D0DAE6"}}),_c('path',{attrs:{"d":"M16.875 3.75h-5a.627.627 0 00-.625.625c0 .344.281.625.625.625h5a.627.627 0 00.625-.625.627.627 0 00-.625-.625zM16.875 6.25h-5a.627.627 0 00-.625.625c0 .344.281.625.625.625h5a.627.627 0 00.625-.625.627.627 0 00-.625-.625zM16.875 8.75h-5a.627.627 0 00-.625.625c0 .344.281.625.625.625h5a.627.627 0 00.625-.625.627.627 0 00-.625-.625z","fill":"#D0DAE6"}})])
          )
        }
      }
    